module.exports = __webpack_public_path__ + "static/media/my-saved-icon-circle.75b58946.svg";